<template>

    <div id="verify">
        <div v-if="!token">
            <div v-if="!verificationRequestSent">
                <h1>Before you proceed</h1>
                <p>For your security, please confirm your email address in order to verify your account.</p>
                <button @click="requestVerificationEmail()" class="btn btn-lg btn-primary">Send Verification Email</button>
            </div>
            <div v-if="verificationRequestSent">
                <h2>Please check your email</h2>
                <p>Look for a message from "Lewis Rice Estate Planning Portal" containing a verification link. Click the link in the email to complete your account set up.</p>
                <p>If you do not receive the verification email, please check your Spam or Junk E-Mail folder, or request another verification email.</p>
                <button @click="requestVerificationEmail()" class="btn btn-lg btn-primary">Re-Send Verification Email</button>
            </div>
        </div>
        <div v-if="token">
            <div v-if="!tokenVerificationComplete">
                <h1>Verifying...</h1>
                <div v-if="tokenVerificationFailed">
                    <button @click="requestVerificationEmail()" class="btn btn-lg btn-primary">Re-Send Verification Email</button>
                </div>
            </div>
            <div v-if="tokenVerificationComplete">
                <h1>Account Verified</h1>
                <p>Your account is now verified and fully activated. You may now view, download, and share your estate planning documents.</p>
                <p>Be sure to bookmark <a href="https://www.lrepdocs.com">https://www.lrepdocs.com</a>.</p>
                <button @click="goHome()" class="btn btn-lg btn-primary">View My Documents</button>
            </div>
        </div>
    </div>

</template>



<script>

    import router from '@/router'
    import { Store } from '@/store.js'
    import UserService from '@/services/user.service'

    export default {

        name: 'verify',

        data() {
            return {
                store: Store,
                token: false,
                verificationRequestSent:false,
                verificationRequestFailed:false,
                tokenVerificationComplete:false,
                tokenVerificationFailed:false
            }
        },

        created: function() {
            this.token = this.$route.query.token
            if (this.token) this.verifyToken(this.token)
        },

        methods: {

            requestVerificationEmail: function() {
                this.resetErrors()
                UserService.requestVerificationEmail()
                    .then(use.bind(this))
                    .catch(failure.bind(this));

                function use(data) {
                    this.token = false;
                    this.verificationRequestSent = true;
                }

                function failure(xhr) {
                    this.token = false;
                    this.verificationRequestFailed = true
                }
            },

            resetErrors: function() {
                this.verificationRequestSent = false
                this.verificationRequestFailed = false
                this.tokenVerificationComplete = false
                this.tokenVerificationFailed = false
            },

            verifyToken: function(token) {
                UserService.verifyToken(token)
                    .then(use.bind(this))
                    .catch(failure.bind(this));

                function use(data) {
                    this.tokenVerificationComplete = true
                    this.store.data.user = {}
                }
                function failure(xhr) {
                    this.tokenVerificationFailed = true
                }
            },

            goHome: function() {
                router.push('/')
            }
        }
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    #verify {

        button {
            margin-top: 2rem;
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }

    }

</style>



// WEBPACK FOOTER //
// Verify.vue?7bb09c8a